export const DELETE_CRONOGRAMA = 'DELETE_CRONOGRAMA'
export const GET_AGENDA = 'GET_AGENDA'
export const REMOVE_EVENT_DAY = 'REMOVE_EVENT_DAY'
export const SET_CURRENT_DAY = 'SET_CURRENT_DAY'
export const SET_DATE_RANGE = 'SET_DATE_RANGE'
export const START_LOADING = 'START_LOADING'
export const STOP_LOADING = 'STOP_LOADING'
export const UPDATE_SCHEDULE_DATES = 'UPDATE_SCHEDULE_DATES'